import createIframe from 'src/js/helpers/create-iframe';

const appendIframe = (url, token) => {
  const appWrp = document.getElementById('app');
  const tokenParam = token ? `?token=${token}` : '';
  const embedUrl = url + tokenParam;
  const iframeElement = createIframe(embedUrl);
  appWrp.appendChild(iframeElement);
};

export default appendIframe;
